import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';
import MUIIcon from '@mui/material/Icon';
import MUIIconButton from '@mui/material/IconButton';

/**
 * This brick creates a customizable icon button with optional disabling and color settings, triggering an event on click.
 */
export default class IconButton extends ReactBrick {
    /**
     * @override
     */
    static getReactComponent($) {
        return () => {
            const icon = useProperty($, 'Icon');
            const disabled = useProperty($, 'Disabled');
            const color = useProperty($, 'Default Color')?.toHexString();
            const sx = {width: 1, height: 1, color};
            const onClick = () => $.trigger('On Click');
            return (
                <MUIIconButton onClick={onClick} disabled={disabled} sx={sx}>
                    <MUIIcon>{icon}</MUIIcon>
                </MUIIconButton>
            );
        };
    }
}

registerBrick('01976929e999115ae6bb', IconButton);
